import './index.scss';
import { useSelector } from 'react-redux';

export default () => {
  const { total, isFetchingOffers } = useSelector(
    ({ OfferReducer }) => OfferReducer,
  );

  return (
    <div className="offer-stats">
      {!isFetchingOffers && <span>{`Showing ${total} deals`}</span>}
    </div>
  );
};
